const state = {
  value: ''
};

const getters = {
  comms: state => state.value
};

const actions = {
  setComms({commit}, value) {
    return commit('SET_COMMS', value);
  },
  clearComms({commit}) {
    return commit('SET_COMMS', '');
  }
};

const mutations = {
  SET_COMMS(state, comms) {
    state.value = comms;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
